import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { DateIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import ehandoverIds from '../../../../ids/Ehandover';

const useStyles = makeStyles((theme) => ({
  Picon: {
    color: '#5f9df6',
    width: '1.25rem',
    height: '1.375rem',
  },
  date: {
    display: 'flex',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginRight: '0.625rem',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  text: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.919rem',
    letterSpacing: '0',
    color: theme.palette.font.sub,
    margin: '0 0.5rem 0 0.625rem',
    display: 'flex',
    alignItems: 'center',
  },
  datepicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.5rem',
      backgroundColor: theme.palette.font.white,
      borderColor: '#e4e7eb',
      paddingLeft: '0.3rem',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.919rem',
      letterSpacing: '0',
      color: theme.palette.font.sub,
      fontWeight: '500',
      marginLeft: '-0.3rem',
      width: '6rem',
      paddingRight: '0',
    },
    '& .MuiIconButton-root': {
      padding: '10px',
    },
  },
}));

export default function DateCom({
  setStartDate,
  setEndDate,
  type,
  startDate,
  endDate,
  handleSetStartDate,
  handleSetEndDate,
}) {
  const classes = useStyles();

  return (
    <div className={classes.date}>
      <div className={classes.label}>{i18n.t('EHANDOVER_FILTER')}</div>
      <KeyboardDatePicker
        id={ehandoverIds.filter + 4}
        autoOk
        className={classes.datepicker}
        size="small"
        onChange={handleSetStartDate}
        keyboardIcon={<DateIcon className={classes.Picon} />}
        value={startDate}
        variant="inline"
        format="DD-MM-yyyy"
        inputVariant="outlined"
        InputAdornmentProps={{ position: 'start' }}
        placeholder={i18n.t('EHANDOVER_START_DATE')}
        // disablePast={type === 'postDay' ? true : false}
        // disableFuture={type === 'postDay' ? false : true}
        maxDate={endDate ?? moment()}
        minDate={moment().add(-4, 'years')}
      />
      <div className={classes.text}>-</div>
      <KeyboardDatePicker
        id={ehandoverIds.filter + 5}
        autoOk
        className={classes.datepicker}
        size="small"
        onChange={handleSetEndDate}
        keyboardIcon={<DateIcon className={classes.Picon} />}
        value={endDate}
        variant="inline"
        inputVariant="outlined"
        format="DD-MM-yyyy"
        InputAdornmentProps={{ position: 'start' }}
        placeholder={i18n.t('EHANDOVER_END_DATE')}
        // disablePast={type === 'postDay' ? true : false}
        // disableFuture={type === 'postDay' ? false : true}
        maxDate={moment().add(2, 'years')}
        minDate={startDate ?? moment().add(-4, 'years')}
      />
    </div>
  );
}
